interface SnapIndicatorProps {
  isVisible: boolean;
  snapTarget: number;
  valueToPixel: (value: number) => number;
  isHorizontal: boolean;
  linePosition: { x: number; y: number };
}

export const SnapIndicator: React.FC<SnapIndicatorProps> = ({
  isVisible,
  snapTarget,
  valueToPixel,
  isHorizontal,
  linePosition
}) => {
  if (!isVisible) return null;

  const targetPx = valueToPixel(snapTarget);
  
  return (
    <g className="snap-indicator">
      {isHorizontal ? (
        <>
          {/* Vertical snap line */}
          <line
            x1={targetPx}
            y1={linePosition.y - 60}
            x2={targetPx}
            y2={linePosition.y + 60}
            stroke="#3B82F6"
            strokeWidth={2}
            strokeDasharray="4,4"
            opacity={0.7}
          />
          {/* Snap target circle */}
          <circle
            cx={targetPx}
            cy={linePosition.y}
            r={8}
            fill="none"
            stroke="#3B82F6"
            strokeWidth={3}
            opacity={0.8}
          />
        </>
      ) : (
        <>
          {/* Horizontal snap line */}
          <line
            x1={linePosition.x - 60}
            y1={targetPx}
            x2={linePosition.x + 60}
            y2={targetPx}
            stroke="#3B82F6"
            strokeWidth={2}
            strokeDasharray="4,4"
            opacity={0.7}
          />
          {/* Snap target circle */}
          <circle
            cx={linePosition.x}
            cy={targetPx}
            r={8}
            fill="none"
            stroke="#3B82F6"
            strokeWidth={3}
            opacity={0.8}
          />
        </>
      )}
    </g>
  );
}; 